import { render, staticRenderFns } from "./CmsRegistCrisis.vue?vue&type=template&id=3b13f4ef&scoped=true&"
import script from "./CmsRegistCrisis.vue?vue&type=script&lang=js&"
export * from "./CmsRegistCrisis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13f4ef",
  null
  
)

export default component.exports